import { plural, t } from "@lingui/macro";
import React from "react";
import InformationPill from "~/applications/OfferSearch/Ui/OfferDetails/InformationPill";
import { Shower } from "~/guidelines/Icon";
import ListItemWithIcon from "~/guidelines/ListItemWithIcon";

export type BathroomAmenityProps = {
  variant?: "list-item" | "pill";
  numberOfBathrooms: number;
  numberOfReducedMobilityBathrooms: number;
};

const BathroomAmenity = ({
  variant = "list-item",
  numberOfBathrooms,
  numberOfReducedMobilityBathrooms,
}: BathroomAmenityProps) => {
  if (numberOfBathrooms === 0 && numberOfReducedMobilityBathrooms === 0) {
    return null;
  }

  let textChildren = "";

  if (numberOfBathrooms > numberOfReducedMobilityBathrooms) {
    textChildren = `
      ${plural(numberOfBathrooms, {
        one: `${numberOfBathrooms} bathroom`,
        other: `${numberOfBathrooms} bathrooms`,
      })} ${
        numberOfReducedMobilityBathrooms > 0
          ? t`including ${numberOfReducedMobilityBathrooms} PRM`
          : ""
      }`;
  }

  if (
    numberOfBathrooms > 0 &&
    numberOfBathrooms === numberOfReducedMobilityBathrooms
  ) {
    textChildren = plural(numberOfBathrooms, {
      one: `${numberOfBathrooms} PRM bathroom`,
      other: `${numberOfBathrooms} PRM bathrooms`,
    });
  }

  if (variant === "pill") {
    return <InformationPill icon={<Shower />} text={textChildren} />;
  }

  return <ListItemWithIcon icon={<Shower />}>{textChildren}</ListItemWithIcon>;
};

export default BathroomAmenity;
